export default __webpack_public_path__ + "static/kara-erickson-c2896e2bf72362c9efee489054d74d68.jpg";